import { splitMncmsBlockers } from "features/pregnancy/utils/mncmsBlockers";

import style from "./MncmsBlockersNotice.module.css";

/**
 * Why this visit cannot be sent to MN-CMS yet (KIN-1943).
 *
 * One renderer for two moments: the pre-flight check before the GP writes the visit up, and the
 * failure after a send that was refused. Both carry the same shape of human-readable strings, and
 * having one component means the warning and the refusal read identically — which is the point,
 * since they come from the same rules.
 *
 * Blockers are rendered as data, never matched against. The backend returns whatever the send
 * itself would refuse with, so the list is not fixed, and a front end that recognised particular
 * entries would quietly drop the ones added after it shipped.
 */
export const MncmsBlockersNotice = ({
  blockers,
  title,
  showHospitalGate = true,
}) => {
  const { waitingOnHospital: gate, fixable } = splitMncmsBlockers(blockers);
  /*
   * The antenatal form already states the gate beside its Send button, so repeating it here put
   * the same sentence on screen twice. The split still happens — the caller decides whether it
   * owns that line already, rather than this component guessing.
   */
  const waitingOnHospital = showHospitalGate ? gate : [];

  if (!waitingOnHospital.length && !fixable.length) return null;

  return (
    <div className={style.notice} role="status">
      {/* The hospital gate first and on its own: it is a status, not a fault, and reading it
          before the fixable list stops the whole box looking like a list of mistakes. */}
      {!!waitingOnHospital.length && (
        <div className={style.waiting}>
          {waitingOnHospital.map((blocker) => (
            <p key={blocker} className={style.waitingText}>
              {blocker}
            </p>
          ))}
        </div>
      )}

      {!!fixable.length && (
        <>
          <p className={style.title}>
            {title ?? "This visit cannot be sent to the maternity hospital yet"}
          </p>
          <ul className={style.list}>
            {fixable.map((blocker) => (
              <li key={blocker}>{blocker}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
